import { useState } from 'react'
import cn from 'classnames'
import { ArrowShortIcon } from 'assets/icons'
import Card from 'components/Wizard/Card'
import { t } from 'helpers'
import s from './index.module.scss'
import { PATHS } from 'types/enums'

interface Props {
	contentKey: string
	type?: 'collapsing'
	containerClassName?: string
}

const ContentPageLayout = ({
	contentKey,
	type,
	containerClassName,
}: Props): JSX.Element => {
	const [collapsedItemIndex, setCollapsedItemIndex] = useState(0)
	const text = t(`APP_${contentKey?.toUpperCase()}_DESCRIPTION`)
		?.replaceAll('h4', 'h5')
		?.replaceAll('h3', 'h4')
		?.replaceAll('h2', 'h3')
		?.replaceAll('h1', 'h2')

	const parsed =
		type === 'collapsing'
			? text
					?.split('<h3>')
					?.slice(1)
					?.map((text) => {
						const [title, desc] = text.split('</h3>')

						return { title, desc }
					})
			: null

	return (
		<>
			{/* <iframe
				// href="//www.youtube.com/watch?v=lJIrF4YjHfQ"
				data-videoid="lJIrF4YjHfQ"
				className="embedded-video-large"
				// frameborder="0"
				// allowfullscreen=""
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				// referrerpolicy="strict-origin-when-cross-origin"
				title="Embed videos and playlists"
				width="400"
				height="230"
				src="https://www.youtube.com/embed/lJIrF4YjHfQ?autoplay=0&amp;cc_lang_pref=en&amp;cc_load_policy=1&amp;controls=2&amp;rel=0&amp;hl=en&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fsupport.google.com&amp;widgetid=1&amp;forigin=https%3A%2F%2Fsupport.google.com%2Fyoutube%2Fanswer%2F171780%3Fhl%3Den&amp;aoriginsup=1&amp;gporigin=https%3A%2F%2Fwww.google.com%2F&amp;vf=6"
				id="widget2"></iframe> */}

			<div
				className={cn(s.container, containerClassName, {
					[s.withEmbed]:
						text?.includes('iframe') ||
						window.location.pathname.includes(PATHS.TIPS),
				})}>
				<Card style={{ backgroundColor: 'transparent' }}>
					<>
						<h1 style={{ paddingBottom: '16px' }}>
							{t(`APP_${contentKey?.toUpperCase()}_TITLE`)}
						</h1>
						{type === 'collapsing' && parsed ? (
							<>
								{parsed.map((text, index) => (
									<CollapseItem
										key={text.title}
										index={index}
										{...text}
										currentCollapsed={collapsedItemIndex}
										setCollapsed={setCollapsedItemIndex}
									/>
								))}
							</>
						) : (
							<div
								className={s.text}
								dangerouslySetInnerHTML={{
									__html: text,
								}}
							/>
						)}
					</>
				</Card>
			</div>
		</>
	)
}

export default ContentPageLayout

const CollapseItem = ({
	title,
	desc,
	index,
	currentCollapsed,
	setCollapsed,
}: {
	title: string
	desc: string
	index: number
	currentCollapsed: number
	setCollapsed: (index: number) => void
}): JSX.Element => {
	const active = currentCollapsed === index

	return (
		<div className={s.text}>
			<div
				onClick={() => setCollapsed(index)}
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '10px',
					cursor: 'pointer',
				}}>
				<div
					style={{
						display: 'flex',
					}}>
					<ArrowShortIcon
						style={{ transform: `rotate(${active ? '90deg' : '-90deg'})` }}
					/>
				</div>
				<h3 dangerouslySetInnerHTML={{ __html: title }}></h3>
			</div>
			<div
				style={{
					height: !active ? '0px' : 'auto',
					overflow: 'hidden',
				}}
				dangerouslySetInnerHTML={{ __html: desc }}></div>
		</div>
	)
}
